import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonMenuButton,
  IonTitle,
  IonContent,
} from "@ionic/react";
import {
  Box,
  Button,
  CircularProgress,
  Container,
  FormControl,
  FormControlLabel,
  IconButton,
  List,
  AlertTitle,
  ListItem,
  ListItemText,
  Paper,
  Radio,
  RadioGroup,
  TextField,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import Alert from "@mui/material/Alert";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { baseUrl, config, getUserData, requestID } from "../../common/utils";
import { useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
import { useBusinessContext } from "../../context/business-context";

export type User = {
  accountName: string;
  accountNumber: number;
  activeloans: number;
  area: string;
  bankName: string;
  businessAddress: string;
  bvn: number;
  churchAddress: string;
  dob: string; // Date of birth as a string
  email: string;
  firstName: string;
  id: number;
  lastName: string;
  lga: string;
  middleName: string;
  nextOfKin: string;
  nextOfKinAddress: string;
  nextOfKinPhone: string;
  nextOfKinRelationship: string;
  parish: string;
  password: string; // This should not be displayed or handled in the UI
  pastorName: string;
  pastorPhone: string;
  phone: string;
  province: string;
  residentialAddress: string;
  savingAmount: string;
  securityAnswer1: string;
  securityAnswer2: string;
  securityQuestion1: string;
  securityQuestion2: string;
  status: number;
  titles: string;
  unitHeadName: string;
  unitHeadPhone: string;
  user_id: string;
  zone: string;
};

const LoanRunning = () => {
  const user_id = getUserData()?.user_id;
  const { selectedBusiness } = useBusinessContext()

  const { name } = useParams<{ name: string }>();
  const url = "http://localhost/rmfwarri";
  const [users, setUsers] = useState<any>([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [status, setStatus] = useState({ loading: false, error: false });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState<string | null>(null);
  const [actionType, setActionType] = useState<"approve" | "reject" | null>(
    null
  );

  const fetchUsers = async () => {
    try {
      const formData = new FormData()
      formData.append("requestID", requestID());
      formData.append("business_id", selectedBusiness.business_id);
      formData.append("branch_id", selectedBusiness.branch_id);
      const response = await axios.post(
        baseUrl() + "applyloans/getAllRunningLoanApplications_caas",
        formData,
        config
      );
      console.log(response);
      const { data } = response.data;
      setUsers(data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching users:", error);
      setLoading(false);
    }
  };

  const filteredUsers = users?.filter(
    (user) =>
      user?.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user?.phone?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, users?.length - page * rowsPerPage);

  const handleApprove = async (userId: string) => {
    try {
      const formData = new FormData();
      formData.append("requestID", requestID());
      formData.append("loanID", userId);
      formData.append("user_id", user_id);

      const response = await axios.post(
        baseUrl() + "applyloans/LoanRunning1",
        formData,
        config
      );
      console.log(response);
      fetchUsers();
      // Refresh the list after approving
      // setUsers(users.map(user =>
      //   user.loanID === userId ? { ...user, approval: '1' } : user
      // ));
    } catch (error) {
      console.error("Error approving loan:", error);
    }
  };

  const handleReject = async (userId) => {
    try {
      const formData = new FormData();
      formData.append("requestID", requestID());
      formData.append("userId", userId);

      const response = await axios.post(
        // url + "/ApplyLoans/LoanRunning1",
        formData,
        config
      );
  
    } catch (error) {
      console.error("Error rejecting loan:", error);
    }
  };

  const handleOpenDialog = (userId: string, action: "approve" | "reject") => {
    setSelectedUserId(userId);
    setActionType(action);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedUserId(null);
    setActionType(null);
  };

  const handleConfirmAction = () => {
    if (actionType && selectedUserId) {
      if (actionType === "approve") {
        handleApprove(selectedUserId);
      } else if (actionType === "reject") {
        handleReject(selectedUserId);
      }
      handleCloseDialog();
    }
  };

  useEffect(() => {
    fetchUsers();
    return () => {};
  }, []);

  //console.log(selectedBusiness)

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonTitle>{name}</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen>
        <Container component="main" sx={{ mt: 4, mb: 2 }}>
          <Paper elevation={3} sx={{ padding: 2 }}>
            <TextField
              variant="outlined"
              margin="normal"
              fullWidth
              label="Search by Email or Phone"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            {loading ? (
              <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
                <CircularProgress />
              </Box>
            ) : (
              <>
                <TableContainer component={Paper} sx={{ mt: 2 }}>
                  <Table sx={{ minWidth: 700 }}>
                    <TableHead>
                      <TableRow>
                        <TableCell>S/N</TableCell>
                        <TableCell>Names</TableCell>
                        <TableCell>Email</TableCell>
                        <TableCell>Phone</TableCell>
                        <TableCell>Loan Amount</TableCell>
                        <TableCell>Monthly Repayment</TableCell>
                        <TableCell>Duration</TableCell>
                        <TableCell>Status</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {filteredUsers
                        ?.slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((user, i) => (
                          <TableRow key={i}>
                            <TableCell>{page * rowsPerPage + i + 1}</TableCell>
                            <TableCell>{user.fullName}</TableCell>
                            <TableCell>{user.email}</TableCell>
                            <TableCell>{user.phone}</TableCell>
                            <TableCell>{user.loanAmount}</TableCell>
                            <TableCell>{user.monthlyRepay}</TableCell>
                            <TableCell>{user.loanDuration}</TableCell>
                            <TableCell>
                              {user.approval == "0" ? (
                                <Box
                                  sx={{ display: "flex", alignItems: "center" }}
                                >
                                  {user.type == "loanPost" && (
                                    <>
                                      {user?.status == 0 ? (
                                        <Button
                                          variant="contained"
                                          disabled={
                                            user?.expected_guarantors !=
                                            user?.guarantee_log
                                          }
                                          color={"warning"}
                                          onClick={() =>
                                            handleOpenDialog(
                                              user.loanID,
                                              "approve"
                                            )
                                          }
                                          sx={{ mr: 1 }}
                                        >
                                          {user?.expected_guarantors !=
                                          user?.guarantee_log
                                            ? " Pending"
                                            : "Approve"}
                                        </Button>
                                      ) : (
                                        <Button
                                          variant="contained"
                                          color="success"
                                          sx={{ mr: 1 }}
                                        >
                                          Active
                                        </Button>
                                      )}
                                    </>
                                  )}
                                  {user.type == "accountPost" && (
                                    <>
                                      {user?.status == 0 ? (
                                        <Button
                                          variant="contained"
                                          disabled={
                                            user?.expected_guarantors !=
                                            user?.guarantee_log
                                          }
                                          color={"warning"}
                                          onClick={() =>
                                            handleOpenDialog(
                                              user.loanID,
                                              "approve"
                                            )
                                          }
                                          sx={{ mr: 1 }}
                                        >
                                          {user?.expected_guarantors !=
                                          user?.guarantee_log
                                            ? " Pending"
                                            : "Approve"}
                                        </Button>
                                      ) : (
                                        <Button
                                          variant="contained"
                                          color="success"
                                          sx={{ mr: 1 }}
                                        >
                                          Active
                                        </Button>
                                      )}
                                    </>
                                  )}
                                  {user.type == "tellerPost" && (
                                    <>
                                      {user?.status == 0 ? (
                                        <Button
                                          variant="contained"
                                          disabled={
                                            user?.expected_guarantors !=
                                            user?.guarantee_log
                                          }
                                          color={"warning"}
                                          onClick={() =>
                                            handleOpenDialog(
                                              user.loanID,
                                              "approve"
                                            )
                                          }
                                          sx={{ mr: 1 }}
                                        >
                                          {user?.expected_guarantors !=
                                          user?.guarantee_log
                                            ? " Pending"
                                            : "Approve"}
                                        </Button>
                                      ) : (
                                        <Button
                                          variant="contained"
                                          color="success"
                                          sx={{ mr: 1 }}
                                        >
                                          Active
                                        </Button>
                                      )}
                                    </>
                                  )}
                                </Box>
                              ) : (
                                <Typography
                                  color={
                                    user.approval == "1"
                                      ? "success.main"
                                      : "error.main"
                                  }
                                >
                                  {user.approval}
                                </Typography>
                              )}
                              {emptyRows < 0 && (
                                <TableRow style={{ height: 53 * emptyRows }}>
                                  <TableCell colSpan={3} />
                                </TableRow>
                              )}
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  rowsPerPageOptions={[10, 25, 50]}
                  component="div"
                  count={filteredUsers?.length ?? 0}
                  // count={users?.length ?? 0}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </>
            )}
          </Paper>
        </Container>
        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          aria-labelledby="confirmation-dialog-title"
          aria-describedby="confirmation-dialog-description"
        >
          <DialogTitle id="confirmation-dialog-title">
            Confirm Action
          </DialogTitle>
          <DialogContent>
            <Typography>
              Are you sure you want to {actionType} this loan application?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDialog} color="primary">
              Cancel
            </Button>
            <Button
              onClick={handleConfirmAction}
              color={actionType === "approve" ? "success" : "error"}
              autoFocus
            >
              {actionType === "approve" ? "Approve" : "Reject"}
            </Button>
          </DialogActions>
        </Dialog>
      </IonContent>
    </IonPage>
  );
};

export default LoanRunning;
